// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-bordered > .panel-heading > .panel-title[data-v-035b1047] {\n  padding-bottom: 10px;\n}\n.campaign-type-group[data-v-035b1047] {\n  display: flex;\n  padding-top: 5px;\n  padding-bottom: 0px;\n  align-items: center;\n  justify-content: space-between;\n}\n.campaign-type-group h p[data-v-035b1047] {\n  font-size: 18px;\n  color: #37474f;\n  margin-bottom: 0px;\n}", ""]);
// Exports
module.exports = exports;
